export const formatToIST = (utcDateString) => {
  const date = new Date(utcDateString);
 
  const datePart = date.toLocaleDateString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
 
  const timePart = date.toLocaleTimeString('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
 
  return (
    <>
      {datePart} <span>,</span>  <b>{timePart}</b>
    </>
  );
};
 
 
export const print_smtp_for_text = (smtp_for) => {
 
  if(smtp_for === 'portal_setting'){
    return "Portal Setting";
  }
 
  if(smtp_for === 'courses'){
    return "Courses";
  }
   if(smtp_for === 'packages'){
    return "Packages";
  }
   if(smtp_for === 'live_test'){
    return "Live Test";
  }
   if(smtp_for === 'profile_update'){
    return "Profile Update";
  }
  return "Blank"
 
}
 
export const nameRegex = /^[A-Za-z\s]+$/;
export const MAX_NAME_LENGTH = 50;
 
export const PINCODE_REGEX = /^[0-9]+$/;
export const PINCODE_LENGTH = 6;
 
 
export const MAX_ADDRESS_WORDS = 300;
 
export const getWordCount = (text = "") =>
  text ? text. length : 0;
;
 
 